exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa.red[data-v-4a87074e]{color:red;cursor:pointer}", ""]);

// exports
